<template>
    <breadCrumbs title="Popover" main="UI Kits" title1="Popover" />
    <div class="container-fluid">
        <div class="row popover-main">
         <basicExamples/>
        </div>
      </div>
</template>
<script>
import basicExamples from "./basicExamples.vue"

    export default{
        name: 'PopoverPage',
        components:{
        basicExamples
    }
    }
</script>